import CustomView from "../custom-view"
import {ViewType} from "../../../gd/const/views/view-type"
import {NavigationSectionType} from "../../navigation/@const"
import NavigationSection from "../../navigation/navigation-section"

export const MANDATORY_ATTENDANCE_VIEW = 'mandatory-attendance'

export default class ViewMyAttendance extends CustomView {

    constructor(data?:any) {

        if (!data?.id) {
            data = {
                id              : MANDATORY_ATTENDANCE_VIEW,
                name            : 'Attendance',
                viewType        : ViewType.MY_ATTENDANCE,
                params          : {
                    location: NavigationSectionType.NAVIGATION_PANEL
                },
                companyId       : gd.companyId,
                userId          : gd.user.id,
                isDynamic       : true,
            }
        }

        super(data)
    }

    addNavigationSortPosition() {
        // set position according to gd.user.settings.navigation.sortPositions if available
        let position = _.indexOf(gd.user.settings.navigation.sortPositions, this.viewId)

        // otherwise add at the end of group 3, right before 3d separator
        if (position < 0) {
            position = _.indexOf(gd.user.settings.navigation.sortPositions, 'separator-g3')
            // insert view id into specified position in sortPositions array
            gd.user.settings.navigation.sortPositions.splice(position, 0, this.viewId)
            gd.user.settings.save()
        }
    }

    removeFromNavigationSortPosition() {
        _.remove(gd.user.settings.navigation.sortPositions, id => id === this.viewId)
        gd.user.settings.save()
    }

    get location():NavigationSectionType {
        return NavigationSectionType.NAVIGATION_PANEL
    }

    set location(viewLocation: NavigationSectionType) {
        // if attendance location is not in NAVIGATION_PANEL then it should be deleted
        if (viewLocation !== NavigationSectionType.NAVIGATION_PANEL) {
            this.actions.delete()
        } else {
            super.location = viewLocation
        }
    }

    get canChangeLocation() {
        return !gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
    }

    get canDelete():boolean {
        return !gd.session.companyUsers.getByUserId(gd.user.id)?.clockInOutEnabled
    }

    get navigationSection() : NavigationSection {
        return gd.navigationStructure.getByCustomViewType(ViewType.MY_ATTENDANCE) ||
            gd.navigationStructure.defaultSection
    }
}
